export enum KYC_UPLOADS {
	PASSPORT = "PASSPORT",
	PHOTO_ID = "PHOTO_ID",
	ADDRESS_PROOF = "ADDRESS_PROOF",
	GENERIC = "GENERIC",
}
